import { Map } from 'immutable';

import { clearErrors, setErrors } from '../errors';
import { getMaterialsError } from '../validations/materials';
import { getSize } from '../iterable/getSize';
import { keepOld } from '../iterable/keepOld';

import { MAX_NUMBER_OF_MATERIALS } from '../../constants/validations';
import { NEW, OPERATIONS, VALUE } from '../../constants/product';
import { EMPTY, SEPARATOR } from '../../constants';
import { ATTRIBUTE } from '../../constants/attributes';
import { FORM } from '../../constants/forms';

export function editMaterials({ materialsToRemove, newMaterials, operation, product: source }) {
  let product = source;
  const operations = [];
  const channel = product.get('channel');
  const productMaterials = product.getIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, VALUE]);

  product = clearErrors({ errors: [ATTRIBUTE.MATERIALS], path: FORM.DETAILS, product });

  function reduceNewMaterials(result, value, key) {
    if (getSize(result.allMaterials) >= MAX_NUMBER_OF_MATERIALS[channel]) return result;

    if (!result.allMaterials.has(key)) {
      result.allMaterials = result.allMaterials.set(key, value);
      result.materialsToAdd = result.materialsToAdd.set(key, value);
    }

    return result;
  }

  switch (operation) {
    case OPERATIONS[channel].MATERIALS.ADD: {
      const { allMaterials, materialsToAdd } = newMaterials.reduce(
        reduceNewMaterials,
        { allMaterials: productMaterials, materialsToAdd: EMPTY.ORDERED_MAP }
      );

      const error = getMaterialsError({ channel, materials: allMaterials });
      product = product.setIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, NEW], materialsToAdd);

      if (error) {
        product = setErrors({ errors: Map({ [ATTRIBUTE.MATERIALS]: error }), path: FORM.DETAILS, product });
      } else if (getSize(materialsToAdd)) {
        operations.push(
          Map({
            type: OPERATIONS[channel].MATERIALS.ADD,
            value: materialsToAdd.toList().join(SEPARATOR.COMMA_SPACE),
          })
        );
      }

      break;
    }

    case OPERATIONS[channel].MATERIALS.DELETE: {
      if (materialsToRemove) {
        const updatedMaterials = productMaterials.deleteAll(materialsToRemove.keySeq());
        product = product.setIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, VALUE], updatedMaterials);
        operations.push(
          Map({
            type: OPERATIONS[channel].MATERIALS.DELETE,
            value: materialsToRemove.toList().join(SEPARATOR.COMMA_SPACE),
          })
        );
      }

      if (getSize(newMaterials)) {
        const { allMaterials, materialsToAdd } = newMaterials.reduce(
          reduceNewMaterials,
          { allMaterials: product.getIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, VALUE]), materialsToAdd: EMPTY.ORDERED_MAP }
        );

        const error = getMaterialsError({ channel, materials: allMaterials });
        product = product.setIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, NEW], materialsToAdd);

        if (error) {
          product = setErrors({ errors: Map({ [ATTRIBUTE.MATERIALS]: error }), path: FORM.DETAILS, product });
        } else if (getSize(materialsToAdd)) {
          operations.push(
            Map({
              type: OPERATIONS[channel].MATERIALS.ADD,
              value: materialsToAdd.toList().join(SEPARATOR.COMMA_SPACE),
            })
          );
        }
      }

      break;
    }

    case OPERATIONS[channel].MATERIALS.CHANGE_TO: {
      if (newMaterials) {
        product = product.setIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, NEW], newMaterials);
      }

      if (materialsToRemove) {
        const filteredMaterials = productMaterials.deleteAll(materialsToRemove.keySeq());
        product = product.setIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, VALUE], filteredMaterials);
      }

      let allMaterials = product.getIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, VALUE]);

      allMaterials = allMaterials.mergeWith(keepOld,
        product.getIn([FORM.DETAILS, ATTRIBUTE.MATERIALS, NEW])
      );

      const error = getMaterialsError({ channel, materials: allMaterials });

      if (error) {
        product = setErrors({ errors: Map({ [ATTRIBUTE.MATERIALS]: error }), path: FORM.DETAILS, product });
      } else {
        operations.push(Map({ type: OPERATIONS[channel].MATERIALS.CHANGE_TO, value: allMaterials.toList() }));
      }

      break;
    }

    default: {
      break;
    }
  }

  return { product, operations };
}
